import current from '@/scripts/current'
import store from '@/store';

/*
numberOfSourceRecords is an array of arrays, where the top level is the year levels, 
and sub level is the state level.  the index[0] is the total counts for all.  For example,
If 2014, 2015, and 2016 is selected and states Alabama and Tennesee are selected then
numberOfSourceRecords will look like:

 [
      0:    Counts for all years
      [
          0:,  Counts for all states for all years
          1:,  Counts for Alabama for all years         
          2:,  Counts for Tennessee for all years
      ],
      1:   - Counts for Year 2014
      [
         0:,  Counts for all states for 2014
          1:,  Counts for Alabama for 2014         
          2:,  Counts for Tennessee for 2014
      ]...
 ]

 initial state
 shape: [{ id, quantity }]
 */
const state = {
    numberOfSourceRecords: {},
    yearVariable: null,
    locationVariable: null
}

// getters
const getters = {
}

function getCountsForLocation(year, location) {
    const stateYearCounts = store.state.dataLists.stateYearCounts;
    var matchingCount = stateYearCounts.filter(c => c.Year === year && c.State === location);
    return matchingCount.length > 0 ? matchingCount[0].NumberOfRecords : 0;
}

function sum(locations, counts) {
    var totalCount = 0;
    for (var i = 0; i < locations.length; ++i) {
        totalCount += counts[locations[i]];
    }
    return totalCount;
}

function sumYears(years, locations, counts) {
    let totalCount2 = 0;
    years.forEach(y => totalCount2 += counts[y][0]);

    //console.log('totalCount2', totalCount2);
    //Object.keys(years).forEach(yk => counts[
    var totalCount = Object.assign(...locations.map(l => ({ [l]: 0 })));
    // Object.keys(years).forEach(yk => {

    //     Object.keys(locations).forEach(lk =>  {
    //         var l = locations[lk];
    //         totalCount[l] += counts[i + 1][l];


    // }}));
    years.forEach(y => {
        locations.forEach(l => {
            totalCount[l] += counts[y][l];
        })
    });
    // for (var i = 0; i < years.length; ++i) {
    //     for (var j = 0; j < locations.length; ++j) {
    //         var l = locations[j];
    //         totalCount[l] += counts[i + 1][l];
    //     }
    // }
    totalCount[0] = sum(locations, totalCount);
    return totalCount;
}

function getCountsForLocations(year, locations) {
    var counts = Object.assign(...locations.map(l => ({ [l.toString()]: getCountsForLocation(year, l) })));
    counts[0] = sum(locations, counts);
    return counts;
}

function getWhichVariableIs(type) {
    if (current.currentType === 'ct') {
        var variableType = ['row', 'column', 'control1', 'control2', 'dependent']
            .filter(vt => current.selectionModel.v[vt] && current.selectionModel.v[vt].type === type);
        return variableType.length > 0 ? variableType[0] : null;
    } else if (current.currentType === 'lr' && current.selectionModel.v.independent) {
        let variableIndex = current.selectionModel.v.independent.map(i => i.type).indexOf(type);
        return variableIndex >= 0 ? variableIndex : null;
    } else return null;

}
// actions
const actions = {
    setCountsByStateYear({ commit, state, rootState }) {
        let yearVariable = getWhichVariableIs('year');
        let locationVariable = getWhichVariableIs('location');
        if (yearVariable === null && locationVariable === null) {
            //Don't bother to count records if not comparing years/locations
            commit('setCountsByStateYear', { 0: { 0: 1 } }, { 0: { 0: 1 } });
        } else {
            let years = store.state.selModel.years.values;
            let locations = rootState.selModel.locations.allIds;

            let numberOfSourceRecords = Object.assign(...years.map(y => ({ [y.toString()]: getCountsForLocations(y, locations) })));
            numberOfSourceRecords[0] = sumYears(years, locations, numberOfSourceRecords);
            commit('setCountsByStateYear', numberOfSourceRecords);
            // let locations2 = rootState.selModel.locations.allIds;
            // let deprecatedCountsByYearState = Object.assign(...years.map((y, i) => ({ [i + 1]: getCountsForLocations(y, locations2) })));
            // deprecatedCountsByYearState[0] = numberOfSourceRecords[0]; // sumYears(years, locations, deprecatedCountsByYearState);

        }
        commit('setYearAndLocationVariables', { yearVariable, locationVariable });
    },
    clearCountsByStateYear({ commit, state, rootState }) {
        commit('setCountsByStateYear', {});
    }
}

// mutations
const mutations = {
    setCountsByStateYear(state, numberOfSourceRecords) {
        state.numberOfSourceRecords = numberOfSourceRecords;
    },
    setYearAndLocationVariables(state, { yearVariable, locationVariable }) {
        state.yearVariable = yearVariable;
        state.locationVariable = locationVariable;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
